<template>
  <div class="app-container" :class="{'padding-tabber':$route.meta.TabbarShow}">
    <div class="layout-content">
       <router-view v-slot="{ Component }">
          <!-- <keep-alive :include="getKeepAliveComs" :key="$route.name"> -->
          <keep-alive :include="getKeepAliveComs">
            <component :is="Component" />
          </keep-alive>
        </router-view>
    </div>
    <div class="layout-footer" v-if="$route.meta.TabbarShow">
      <TabBar :data="tabbars" :defaultActive="active" @change="handleChange" />
    </div>
  </div>
</template>

<script>
import TabBar from '@/components/TabBar'
import icon_5 from '@/assets/images/tabbar/icon_5@2x.png'
import icon_6 from '@/assets/images/tabbar/icon_6@2x.png'
import icon_3 from '@/assets/images/tabbar/icon_3@2x.png'
import icon_5_active from '@/assets/images/tabbar/icon_5_active@2x.png'
import icon_6_active from '@/assets/images/tabbar/icon_6_active@2x.png'
import icon_3_active from '@/assets/images/tabbar/icon_3_active@2x.png'
import { channelsUser } from '@/api/home'
export default {
  name: 'AppLayout',
  data() {
    return {
      active: 0,
      tabbars: [
        {
          title: '最新政策',
          to: {
            name: 'Home'
          },
          icon: icon_5,
          iconActive: icon_5_active,
        },
        // {
        //   title: '严选商城',
        //   to: {
        //     name: 'Mall'
        //   },
        //   icon: icon_2,
        //   iconActive: icon_2_active,
        // },
        {
          title: '政策情报',
          to: {
            name: 'EnterpriseMatchCopy'
          },
          icon: icon_6,
          iconActive: icon_6_active,
        },
        // {
        //   title: '申报推荐',
        //   to: {
        //     name: 'EnterpriseMatch'
        //   },
        //   icon: icon_6,
        //   iconActive: icon_6_active,
        // },
        {
          title: '个人中心',
          to: {
            name: 'Setup'
          },
          icon: icon_3,
          iconActive: icon_3_active
        }
      ]
    }
  },
  components: {
    TabBar
  },
  computed: {
    getKeepAliveComs() {
      console.log(this.$store.state.routerCache.KEEP_ALIVE_COMS)
      return this.$store.state.routerCache.KEEP_ALIVE_COMS;
    }
  },
  mounted() {
    var that = this
    setTimeout(function () {
      let channels_id = that.getUrlValue('channels_id') || ''
      if (channels_id) {
        that.getChannelsInfo(channels_id)
      }
    },50)
  },
  methods: {
    handleChange(v) {
      console.log('tab value:', v)
      this.active = v
    },
    getUrlValue(kValue) {
      var url = window.location.href;  //当前页面的地址
      var reg = /([^?&=]+)=([^?&=]+)/g, obj = {}, str = url;
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      })
      for (var keyName in obj) {
        if (keyName == kValue) {
          let val = obj[keyName]
          if (val.indexOf("#") > 0) {
            val = val.substring(0, val.indexOf("#"))
          }
          return val;
        }
      }
    },
    async getChannelsInfo(channels_id) {
      try {
        let res = await channelsUser({ channels_id: channels_id })
        document.title = res.result.name ? res.result.name: ""
      } catch {
        
      }
    },
  }
}
</script>
